import { Injector } from '../../../injector/classes/injector';
import { NodeTypeConfigHelper, NodeTypeConfigHelperConstructor } from './node-config-helper';


export abstract class NodeConfigHelperService {
  static deps: any[] = [
    Injector
  ];

  protected _configHelpers: { [key: string]: NodeTypeConfigHelper } = {};

  protected constructor(protected _injector: Injector) {
  }

  abstract getConfigHelperClass(nodeTypeIdentifier: string): NodeTypeConfigHelperConstructor;

  abstract getConfigHelperClassInstance(nodeTypeIdentifier: string): NodeTypeConfigHelper;

  getConfigHelper(nodeTypeIdentifier: string): NodeTypeConfigHelper {
    const existingRef = this._configHelpers[nodeTypeIdentifier];

    if (existingRef) {
      return existingRef;
    }

    const newRef = this.getConfigHelperClassInstance(nodeTypeIdentifier);

    this._configHelpers[nodeTypeIdentifier] = newRef;

    return newRef;
  }
}
